import { join } from "node:path";
import chalk from "chalk";
import ora from "ora";
import prompts from "prompts";
import { createConfigFile, DEFAULT_CONFIG } from "../utils/config";

type InitOptions = {
  output?: string;
  typescript?: boolean;
  force?: boolean;
};

export async function initCommand(options: InitOptions): Promise<void> {
  const spinner = ora("Creating configuration file...").start();

  try {
    const cwd = process.cwd();

    // Check if config already exists and handle force flag
    const configPath = join(cwd, ".pixelarticonsrc.json");
    const fs = require("fs-extra");

    if (fs.existsSync(configPath) && !options.force) {
      spinner.stop();

      const response = await prompts({
        type: "confirm",
        name: "overwrite",
        message: "Config file already exists. Overwrite?",
        initial: false,
      });

      if (!response.overwrite) {
        console.log(chalk.yellow("Configuration file creation cancelled."));
        process.exit(0);
      }

      spinner.start("Creating configuration file...");
    }

    // Prepare custom config based on options
    const customConfig = {
      ...(options.output && { output: options.output }),
      ...(options.typescript !== undefined && {
        typescript: options.typescript,
      }),
    };

    // Create config file
    const createdPath = await createConfigFile(
      cwd,
      customConfig,
      options.force,
    );

    spinner.succeed(chalk.green("Configuration file created successfully!"));
    console.log(chalk.cyan(`\nConfig file: ${createdPath}`));
    console.log(chalk.dim("\nDefault configuration:"));
    console.log(
      chalk.dim(`  output: ${options.output || DEFAULT_CONFIG.output}`),
    );
    console.log(
      chalk.dim(
        `  typescript: ${options.typescript ?? DEFAULT_CONFIG.typescript}`,
      ),
    );
    console.log(chalk.dim(`  extension: ${DEFAULT_CONFIG.extension}`));
    console.log(chalk.dim(`  indexFile: ${DEFAULT_CONFIG.indexFile}`));
    console.log(chalk.cyan("\nNext steps:"));
    console.log(
      chalk.white(
        `  1. Run ${chalk.bold("@pyyupsk/pixelarticons list")} to see available icons`,
      ),
    );
    console.log(
      chalk.white(
        `  2. Run ${chalk.bold("@pyyupsk/pixelarticons add <icon-name>")} to generate components`,
      ),
    );
    console.log(
      chalk.white(
        `  3. Run ${chalk.bold("@pyyupsk/pixelarticons add --all")} to generate all icons`,
      ),
    );
  } catch (error) {
    spinner.fail(chalk.red("Failed to create configuration file"));
    console.error(chalk.red((error as Error).message));
    process.exit(1);
  }
}
